import { render, staticRenderFns } from "./CustomFrame.vue?vue&type=template&id=9ffa2420&scoped=true&"
import script from "./CustomFrame.vue?vue&type=script&lang=js&"
export * from "./CustomFrame.vue?vue&type=script&lang=js&"
import style0 from "./CustomFrame.vue?vue&type=style&index=0&id=9ffa2420&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffa2420",
  null
  
)

export default component.exports